module.exports = __webpack_public_path__ + "img/pro_feature_flight_compensation.6b293a8.png";